import script from "./hpDatenschutz.vue?vue&type=script&setup=true&lang=js"
export * from "./hpDatenschutz.vue?vue&type=script&setup=true&lang=js"

import "./hpDatenschutz.vue?vue&type=style&index=0&id=206a840c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206a840c"]])

export default __exports__